module.exports = __webpack_public_path__ + "img/Phoebe_Chen@2x.e2bb8916.png";